import gql from 'graphql-tag';

export const NAME = 'compositions_CaseContacts_caseContactsQuery';

const query = gql`
  query ${NAME} (
    $caseNumber: String
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      caseContacts {
        callbackEta
        callbackRollTime
        caseId
        contactType
        createdAt
        email
        id
        label
        name
        phone
        phoneExt
      }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CaseContacts/withContacts/caseContactsQuery.js